module.exports = __webpack_public_path__ + "assets/img/kv-68714616.jpg";